(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["xfun-delivery-times"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('xfun-cart-delivery')) {
    customElements.define('xfun-cart-delivery', class extends HTMLElement {
      connectedCallback() {
        if (this.onCartChange) return;
        this.onCartChange = event => {
          const html = event.detail?.response?.sections?.['cart-footer'];
          if (!html) return;
          const document = new DOMParser().parseFromString(html, 'text/html');
          const estimate = document.querySelector('[data-cart-footer] [data-xfun-extended-delivery]');
          const paragraph = this.querySelector('p');
          if (!estimate || !paragraph) return;
          const copy = estimate.dataset.xfunKnitDelivery === 'true'
            ? this.dataset.knitDelivery
            : estimate.dataset.xfunExtendedFiveWeeks === 'true'
              ? this.dataset.extendedFiveWeeks
              : estimate.dataset.xfunExtendedDelivery === 'true' ? this.dataset.extended : this.dataset.standard;
          paragraph.textContent = new DOMParser().parseFromString(copy, 'text/html').body.textContent;
        };
        this.events = ['shapes:cart:afteradditem', 'shapes:cart:cartqtychange', 'shapes:cart:update'];
        this.events.forEach(name => window.addEventListener(name, this.onCartChange));
      }
      disconnectedCallback() {
        this.events?.forEach(name => window.removeEventListener(name, this.onCartChange));
        this.onCartChange = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["xfun-footer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('xfun-footer-navigation')) {
    customElements.define('xfun-footer-navigation', class extends HTMLElement {
      connectedCallback() {
        if (this.media) return;
        this.media = window.matchMedia('(min-width: 990px)');
        this.syncLayout = () => {
          this.querySelectorAll('details').forEach((group) => {
            group.open = this.media.matches;
            const summary = group.querySelector('summary');
            if (this.media.matches) {
              summary.setAttribute('tabindex', '-1');
              summary.setAttribute('aria-disabled', 'true');
            } else {
              summary.removeAttribute('tabindex');
              summary.removeAttribute('aria-disabled');
            }
          });
        };
        this.keepDesktopOpen = (event) => {
          if (this.media.matches && event.target.closest('summary')) event.preventDefault();
        };
        this.media.addEventListener('change', this.syncLayout);
        this.addEventListener('click', this.keepDesktopOpen);
        this.syncLayout();
      }
      disconnectedCallback() {
        if (!this.media) return;
        this.media.removeEventListener('change', this.syncLayout);
        this.removeEventListener('click', this.keepDesktopOpen);
        this.media = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["xfun-header"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.XfunCollectionMenus) return;
    window.XfunCollectionMenus = true;
    const menus = () => [...document.querySelectorAll('[data-xfs-desktop-menu]')];
    const close = (except) => menus().forEach((menu) => {
      if (menu !== except) menu.open = false;
    });
    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const menu = event.target.closest('[data-xfs-desktop-menu]');
      close(menu);
      if (menu && event.target.closest('a[href]')) menu.open = false;
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !(event.target instanceof Element)) return;
      const menu = event.target.closest('[data-xfs-desktop-menu][open]');
      if (!menu) return;
      menu.open = false;
      menu.querySelector('summary')?.focus();
    });
    document.addEventListener('focusin', (event) => {
      if (!(event.target instanceof Element)) return;
      close(event.target.closest('[data-xfs-desktop-menu]'));
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["xfun-product-image-viewer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('xfun-product-images')) {
    customElements.define('xfun-product-images', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) {
          if (this.resume) this.resume();
          return;
        }
        const gallery = this.closest('[data-xfun-gallery]');
        const viewport = gallery && gallery.querySelector('[data-xfun-gallery-viewport]');
        const dialog = this.querySelector('dialog');
        if (!viewport || !dialog || typeof dialog.showModal !== 'function') return;
        this.initialized = true;
        const slides = Array.from(viewport.querySelectorAll('[data-xfun-gallery-slide]'));
        const thumbs = Array.from(this.querySelectorAll('[data-xfi-thumb]'));
        const photos = thumbs.filter(thumb => thumb.dataset.source);
        const opener = this.querySelector('[data-xfi-open]');
        const canvas = this.querySelector('[data-xfi-canvas]');
        const mount = this.querySelector('[data-xfi-image]');
        const zoom = this.querySelector('[data-xfi-zoom]');
        const previous = this.querySelector('[data-xfi-prev]');
        const next = this.querySelector('[data-xfi-next]');
        const currentLabel = this.querySelector('[data-xfi-current]');
        const thumbRail = this.querySelector('.xfi__thumbs');
        const slideThumbs = slides.map(slide => thumbs.find(thumb => thumb.dataset.mediaId === slide.dataset.mediaId));
        let selected = null;
        let viewed = 0;
        let frame = null;
        let slidePositions = [];
        let restoreOverflow = '';
        let swipeStart = null;
        const activePointers = new Set();
        const motion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        const select = thumb => {
          if (!thumb || selected === thumb) return;
          selected = thumb;
          thumbs.forEach(item => item.toggleAttribute('data-active', item === thumb));
          thumbs.forEach(item => item.setAttribute('aria-current', String(item === thumb)));
          currentLabel.textContent = `${thumb.dataset.view} · ${thumbs.indexOf(thumb) + 1} / ${thumbs.length}`;
          opener.hidden = !thumb.dataset.source;
          if (thumbRail && thumbRail.clientWidth) {
            const left = thumb.getBoundingClientRect().left - thumbRail.getBoundingClientRect().left + thumbRail.scrollLeft;
            const right = left + thumb.offsetWidth;
            if (left < thumbRail.scrollLeft) thumbRail.scrollTo({ left, behavior: motion() });
            else if (right > thumbRail.scrollLeft + thumbRail.clientWidth) thumbRail.scrollTo({ left: right - thumbRail.clientWidth, behavior: motion() });
          }
        };
        const measureSlides = () => {
          const edge = viewport.getBoundingClientRect().left;
          const left = viewport.scrollLeft;
          slidePositions = slides.map(slide => slide.getBoundingClientRect().left - edge + left);
        };
        const syncSelection = () => {
          const left = viewport.scrollLeft;
          let closest = 0;
          let distance = Infinity;
          slidePositions.forEach((position, index) => {
            const current = Math.abs(position - left);
            if (current < distance) { distance = current; closest = index; }
          });
          select(slideThumbs[closest]);
        };
        const scheduleSync = () => {
          if (frame !== null) return;
          frame = requestAnimationFrame(() => {
            frame = null;
            syncSelection();
          });
        };
        const finishScroll = () => {
          if (frame !== null) cancelAnimationFrame(frame);
          frame = null;
          syncSelection();
        };
        thumbs.forEach(thumb => {
          const slide = slides.find(item => item.dataset.mediaId === thumb.dataset.mediaId);
          if (!slide) return;
          const image = slide.querySelector('img');
          if (image && thumb.dataset.source) image.alt = thumb.dataset.alt;
          thumb.addEventListener('click', () => {
            measureSlides();
            const left = slide.getBoundingClientRect().left - viewport.getBoundingClientRect().left + viewport.scrollLeft;
            viewport.scrollTo({ left, behavior: motion() });
            scheduleSync();
          });
        });
        const resetZoom = () => {
          canvas.classList.remove('is-zoomed');
          zoom.setAttribute('aria-pressed', 'false');
          zoom.textContent = this.dataset.zoomIn;
          canvas.scrollTo(0, 0);
        };
        const refreshZoom = () => {
          if (!dialog.open) return;
          const photo = photos[viewed];
          zoom.disabled = Number(photo.dataset.width) <= canvas.clientWidth - 32 && Number(photo.dataset.height) <= canvas.clientHeight - 32;
          if (zoom.disabled) resetZoom();
        };
        const show = index => {
          viewed = Math.max(0, Math.min(photos.length - 1, index));
          const photo = photos[viewed];
          resetZoom();
          const image = document.createElement('img');
          image.alt = photo.dataset.alt;
          image.width = Number(photo.dataset.width);
          image.height = Number(photo.dataset.height);
          image.decoding = 'async';
          image.src = photo.dataset.source;
          mount.style.setProperty('--xfi-image-width', `${photo.dataset.width}px`);
          mount.style.setProperty('--xfi-image-height', `${photo.dataset.height}px`);
          mount.replaceChildren(image);
          this.querySelector('[data-xfi-view]').textContent = photo.dataset.view;
          this.querySelector('[data-xfi-count]').textContent = `${viewed + 1} / ${photos.length}`;
          previous.disabled = viewed === 0;
          next.disabled = viewed === photos.length - 1;
          previous.hidden = photos.length < 2;
          next.hidden = photos.length < 2;
          refreshZoom();
        };
        opener.addEventListener('click', () => {
          syncSelection();
          if (!selected || !selected.dataset.source) return;
          show(photos.indexOf(selected));
          restoreOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
          dialog.showModal();
          refreshZoom();
        });
        this.querySelector('[data-xfi-close]').addEventListener('click', () => dialog.close());
        previous.addEventListener('click', () => show(viewed - 1));
        next.addEventListener('click', () => show(viewed + 1));
        canvas.addEventListener('pointerdown', event => {
          if (event.pointerType === 'mouse' || canvas.classList.contains('is-zoomed')) return;
          activePointers.add(event.pointerId);
          if (activePointers.size > 1) { swipeStart = null; return; }
          swipeStart = { id: event.pointerId, x: event.clientX, y: event.clientY };
        }, { passive: true });
        canvas.addEventListener('pointercancel', event => { activePointers.delete(event.pointerId); swipeStart = null; }, { passive: true });
        canvas.addEventListener('pointerup', event => {
          activePointers.delete(event.pointerId);
          if (!swipeStart || event.pointerId !== swipeStart.id) return;
          const dx = event.clientX - swipeStart.x;
          const dy = event.clientY - swipeStart.y;
          swipeStart = null;
          if (canvas.classList.contains('is-zoomed')) return;
          if (Math.abs(dx) >= 48 && Math.abs(dx) > Math.abs(dy) * 1.3) show(viewed + (dx < 0 ? 1 : -1));
        }, { passive: true });
        zoom.addEventListener('click', () => {
          const active = canvas.classList.toggle('is-zoomed');
          zoom.setAttribute('aria-pressed', String(active));
          zoom.textContent = active ? this.dataset.zoomOut : this.dataset.zoomIn;
          requestAnimationFrame(() => canvas.scrollTo({ left: active ? (canvas.scrollWidth - canvas.clientWidth) / 2 : 0, top: active ? (canvas.scrollHeight - canvas.clientHeight) / 2 : 0 }));
        });
        dialog.addEventListener('keydown', event => {
          if (canvas.classList.contains('is-zoomed')) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            show(viewed + (event.key === 'ArrowLeft' ? -1 : 1));
          }
        });
        dialog.addEventListener('close', () => {
          document.documentElement.style.overflow = restoreOverflow;
          const photo = photos[viewed];
          const slide = photo && slides.find(item => item.dataset.mediaId === photo.dataset.mediaId);
          if (slide) {
            measureSlides();
            viewport.scrollTo({ left: slide.getBoundingClientRect().left - viewport.getBoundingClientRect().left + viewport.scrollLeft, behavior: 'auto' });
            select(photo);
          }
          swipeStart = null;
          activePointers.clear();
          resetZoom();
          mount.replaceChildren();
          opener.focus({ preventScroll: true });
        });
        const observer = new ResizeObserver(refreshZoom);
        const galleryObserver = new ResizeObserver(() => {
          measureSlides();
          scheduleSync();
        });
        this.resume = () => {
          viewport.addEventListener('scroll', scheduleSync, { passive: true });
          viewport.addEventListener('scrollend', finishScroll, { passive: true });
          observer.observe(canvas);
          galleryObserver.observe(viewport);
          measureSlides();
          syncSelection();
        };
        this.cleanup = () => {
          observer.disconnect();
          galleryObserver.disconnect();
          viewport.removeEventListener('scroll', scheduleSync);
          viewport.removeEventListener('scrollend', finishScroll);
          if (frame !== null) cancelAnimationFrame(frame);
          frame = null;
          if (dialog.open) dialog.close();
        };
        this.hidden = false;
        gallery.setAttribute('data-xfi-ready', '');
        this.resume();
      }
      disconnectedCallback() {
        if (this.cleanup) this.cleanup();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
